import { Value as ReactSVGPanZoomValue } from 'react-svg-pan-zoom';

import {
  SELECT_TOOL_PAN,
  SELECT_TOOL_ZOOM_IN,
  SELECT_TOOL_ZOOM_OUT,
  UPDATE_2D_CAMERA
} from '../constants';

export function updateCameraView(value: ReactSVGPanZoomValue) {
  return {
    type: UPDATE_2D_CAMERA,
    value
  };
}

export function selectToolPan() {
  return {
    type: SELECT_TOOL_PAN
  };
}

export function selectToolZoomOut() {
  return {
    type: SELECT_TOOL_ZOOM_OUT
  };
}

export function selectToolZoomIn() {
  return {
    type: SELECT_TOOL_ZOOM_IN
  };
}
